import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Now from './pages/Now';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/now" element={<Now />} />
    </Routes>
  );
}

export default App;
